export const EXTENSIONS = {
  JPEG: 'jpeg',
  JPG: 'jpg',
  PDF: 'pdf',
  PNG: 'png',
  XML: 'xml',
};

export const MIME_TYPES = [
  {
    description: 'Graphics Interchange Format',
    mime: 'image/gif',
    name: 'gif',
    type: 'image',
    visor: 'image',
  },
  {
    description: '',
    mime: 'image/jpeg',
    name: EXTENSIONS.JPG,
    type: 'image',
    visor: 'image',
  },
  {
    description: '',
    mime: 'image/jpeg',
    name: EXTENSIONS.JPEG,
    type: 'image',
    visor: 'image',
  },
  {
    description: 'Adobe Portable Document Format',
    mime: 'application/pdf',
    name: EXTENSIONS.PDF,
    type: 'application',
    visor: 'document',
  },
  {
    description: '',
    mime: 'image/png',
    name: EXTENSIONS.PNG,
    type: 'image',
    visor: 'image',
  },
  {
    description: 'Gráficos Vectoriales',
    mime: 'image/svg+xml',
    name: 'svg',
    type: 'image',
    visor: 'image',
  },
  {
    description: 'Formato de archivo de imagen etiquetado',
    mime: 'image/tiff',
    name: 'tif',
    type: 'image',
    visor: 'image',
  },
  {
    description: 'Formato de archivo de imagen etiquetado',
    mime: 'image/tiff',
    name: 'tiff',
    type: 'image',
    visor: 'image',
  },
  {
    description: 'Imágenes WEBP',
    mime: 'image/webp',
    name: 'webp',
    type: 'image',
    visor: 'image',
  },
  {
    description: 'XML',
    mime: 'application/xml',
    name: EXTENSIONS.XML,
    type: 'application',
    visor: 'code',
  },
];
